import { render, staticRenderFns } from "./LayoutPanelFooter.vue?vue&type=template&id=07c29534&"
import script from "./LayoutPanelFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutPanelFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports